export const maintenanceCatalog = {
    getLimit(){
        const url = '/api/form/system/config/limits/service';
        return url;
    },

    getCities(params) {
        const url = `/api/form/${params.brandId}/service/dealer/cities/${params.dealerId}`;
        return url;
    },

    getModels(params) {
        const url = `/api/form/${params.brandId}/service/catalog/models`;
        return url;
    },

    getAirTypes(params) {
        const url = `/api/form/${params.brandId}/service/catalog/airTypes?model=${params.modelId}`;
        return url;
    },

    getFuelTypes(params) {
        const url = `/api/form/${params.brandId}/service/catalog/fuelTypes?model=${params.modelId}`
                  + `&air_type=${params.airTypeId}`;
        return url;
    },

    getEngines(params) {
        const url = `/api/form/${params.brandId}/service/catalog/engines?model=${params.modelId}`
                  + `&air_type=${params.airTypeId}&fuel_type=${params.fuelTypeId}`;
        return url;
    },

    getModelYears(params) {
        const url = `/api/form/${params.brandId}/service/catalog/modelYears?model=${params.modelId}`
                  + `&air_type=${params.airTypeId}&fuel_type=${params.fuelTypeId}&engine_capacity=${params.engine}`;
        return url;
    },

    getDealers(params) {
        let url = `/api/form/${params.brandId}/service/dealer/centers?google_city_id=${params.placeId || ''}`;
        if(params.cityId) {
            url = `${url}&city_id=${params.cityId}`;
        }
        if(params.dealerId) {
            url = `${url}&dealer=${params.dealerId}`;
        }
        return url;
    },

    getDealerInfo(params) {
        const url = `/api/form/${params.brandId}/service/dealer/center_booking_info/${params.centerId}`;
        return url;
    },

    getTimeSlots(params) {
        let url = `/api/form/${params.brandId}/service/time_slots?center=${params.centerId}`;
        if(params.adviserId) {
            url = `${url}&adviser=${params.adviserId}`;
        }
        return url;
    },

    getBookingInfo(params) {
        const url = `/api/form/${params.brandId}/service/complete`;
        return url;
    },

    getPackages(params) {
        const url = `/api/form/${params.brandId}/service/packages/${params.centerId}`;
        return url;
    },

    getReviewCampaigns(params) {
        const url = `/api/form/${params.brandId}/service/review_campaign`;
        return url;
    },

    sendCodeAgain(params) {
        const url = `/api/form/${params.brandId}/service/send_code_again`;
        return url;
    }
};



// WEBPACK FOOTER //
// ./src/urlConstructor/maintenanceCatalog.js